
import React from 'react';
import { Button } from '../../../components/base/Button';

export const AreasSection: React.FC = () => {
  const areas = [
    'Coventry', 'Warwick', 'Leamington Spa', 'Rugby',
    'Nuneaton', 'Kenilworth', 'Bedworth', 'Stratford-upon-Avon'
  ];

  return (
    <section className="py-20 bg-emerald-600 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Map%20of%20Coventry%20and%20West%20Midlands%20area%20showing%20service%20coverage%2C%20professional%20insulation%20service%20area%20map%2C%20local%20business%20coverage%2C%20Coventry%20city%20center%20and%20surrounding%20towns&width=600&height=400&seq=service-area&orientation=landscape"
              alt="Loft Insulation Service Coverage"
              className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
            />
          </div>
          
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Areas We Serve</h2>
            <h3 className="text-xl font-semibold mb-4">Loft Insulation Service Coverage</h3>
            <p className="text-emerald-100 leading-relaxed mb-6">
              Based in Coventry, we provide our professional loft insulation services locally to the following areas:
            </p>
            
            <div className="grid grid-cols-2 gap-3 mb-8">
              {areas.map((area, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <i className="ri-map-pin-line text-emerald-200"></i>
                  <span className="text-emerald-100">{area}</span>
                </div>
              ))}
            </div>
            
            <Button 
              variant="outline" 
              className="border-white text-white hover:bg-white hover:text-emerald-600"
              href="/areas"
            >
              Learn More About Service Areas
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
